/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Frontend SPA Contract API
 * Canonical API contract entrypoint.
 *
 * Source architecture:
 * - split by module / bounded context
 * - one file per aggregate root
 * - child entities remain owned by aggregate root
 * - cross-cutting technical concerns live under `openapi/common`
 *
 * OpenAPI spec version: 1.0.0
 */
import * as zod from "zod";
import {Key} from "./key.zod";

export const CustomerOfferBindingDefinitionDto = zod
  .object({
    key: Key,
    label: zod.string(),
    description: zod.string(),
  })
  .describe(
    "Supported binding metadata, not a resolved user value. Labels and descriptions use English; key is stable identity.",
  );

export type CustomerOfferBindingDefinitionDto = zod.input<typeof CustomerOfferBindingDefinitionDto>;
export type CustomerOfferBindingDefinitionDtoOutput = zod.output<
  typeof CustomerOfferBindingDefinitionDto
>;
